import { CreateCampaignParams } from 'src/api/campaignRegistry';

// Constants
export const MAX_SAMPLE_MESSAGES = 5;

export const SAMPLE_MESSAGE_FIELD_MAX_ROWS = 6;

export const getExistingSampleMessages = (
  values: Partial<CreateCampaignParams>,
): number[] => {
  const existingSampleMessages: number[] = [];
  for (let i = 1; i <= MAX_SAMPLE_MESSAGES; i++) {
    const sampleKey = `sample${i}` as keyof CreateCampaignParams;
    const sampleValue = values[sampleKey] as string | undefined;
    if (sampleValue && sampleValue.trim()) {
      existingSampleMessages.push(i);
    }
  }
  return existingSampleMessages;
};
